app.service('warrantyChangeConflictModal', function (productCardConfig, productInstalmentsModal, store, modal, productCardManager) {

	let config;

	function init() {
		config = productCardConfig.getData();
	}

	function handleWarrantyConflict(warrantyId) {

		if (store.data.isOutlet) {
			showInstalmentConflictMessage(() => handleOutletWarrantyConfirmation(warrantyId));
		} else {
			showInstalmentConflictMessage(() => handleWarrantyConfirmation(warrantyId));
		}
	}

	function handleOutletWarrantyConfirmation(warrantyId) {
		const {defaultInstalmentOption} = config.configurationDto.availableOutletCategories
			.find(option => parseInt(option.outletCategoryId) === parseInt(store.data.outletCategoryId));

		if (defaultInstalmentOption && defaultInstalmentOption.available && defaultInstalmentOption.instalmentWarrantyId) {
			productInstalmentsModal.show({warrantyId});
		} else {
			if (warrantyId) {
				productCardManager.addWarranty(warrantyId, "ONE_TIME", 'PRODUCT_CARD_WARRANTY_SECTION_INSTALLMENT');
			} else {
				productCardManager.removeWarranty();
			}

			store.dispatch('setDefaultOutletContext', { outletCategoryId: store.data.outletCategoryId });
		}
	}

	function handleWarrantyConfirmation(warrantyId) {
		const {defaultInstalmentOption} = config.configurationDto;
		if (defaultInstalmentOption.available && defaultInstalmentOption.instalmentWarrantyId) {
			productInstalmentsModal.show({warrantyId});
		} else {
			if (warrantyId) {
				productCardManager.addWarranty(warrantyId, "ONE_TIME", 'PRODUCT_CARD_WARRANTY_SECTION_INSTALLMENT'); // przy zmianie PG na KP, jeśli wcześniej wybrany PG na productInstalmentsModal
			} else {
				productCardManager.removeWarranty();
			}

			store.dispatch('setDefaultContext');
		}
	}

	function showInstalmentConflictMessage(callback) {

		const {header, content} = config.warrantyChangeConflictMessage;

		modal.generate({
			id: 'instalment-warranty-conflict',
			cssClass: 'instalment-warranty-conflict',
			header,
			content: `<p>${content}</p>`,
			buttons: [{
				text: 'Tak',
				cssClass: 'confirm',
				click: function () {
					callback();
					modal.close();
				}
			}, {
				text: 'Nie',
				cssClass: 'deny',
				click: modal.close
			}]
		});
	}

	return {
		init,
		handleWarrantyConflict
	};
});